export default "__VITE_ASSET__BiTnzXTX__"